export default "__VITE_ASSET__d3f7efb7__"